import React from "react";
import Sidebar from "../components/Sidebar";

const Dashboard = () => {
  return (
    <div className="min-h-screen flex bg-gray-50">
      <Sidebar />

      <main className="flex-1 p-6 overflow-y-auto">
        <div className="mb-4">
          <h1 className="text-2xl font-semibold">
            Dashboard
          </h1>
          <p className="text-sm mt-1">
            Welcome to the admin dashboard. You can manage data from the sidebar.
          </p>
        </div>

        <div className="h-px mb-6" />
      </main>
    </div>
  );
};

export default Dashboard;
